module.exports = __webpack_public_path__ + "img/冀运希@2x.8c6ab97e.png";